import type { LegalDocument } from '../types';

/** Источник: «Политика использования файлов cookie.docx». Файл сгенерирован — правки вносите в документ. */
export const doc: LegalDocument = {
  title: 'Cookie Policy',
  blocks: [
    {
      kind: 'heading',
      number: '1.',
      text: 'Общие положения',
    },
    {
      kind: 'para',
      number: '1.1.',
      text: 'Настоящая Политика использования файлов cookie (далее — Политика) устанавливает порядок использования файлов cookie и аналогичных технологий (пикселей, тегов, SDK, локального хранилища и иных идентификаторов) при использовании мобильного приложения Aura (далее — Приложение) и веб-сайта https://aura-vibe.site (далее — Сайт).',
    },
    {
      kind: 'para',
      number: '1.2.',
      text: 'Политика разработана и применяется ООО «Falcon», зарегистрированным в соответствии с законодательством Республики Абхазия (ОГРН 108РА000782, ИНН 11008213, юридический адрес: проспект Мира 16, г. Сухум, Республика Абхазия) (далее — Компания).',
    },
    {
      kind: 'para',
      number: '1.3.',
      text: 'Настоящая Политика является неотъемлемой частью Политики конфиденциальности, Пользовательского соглашения и Политики защиты детей, которые являются приложениями к Пользовательскому соглашению и также размещены на Сайте.',
    },
    {
      kind: 'para',
      number: '1.4.',
      text: 'Политика разработана с учетом требований законодательства Республики Абхазия, Российской Федерации, стран СНГ, а также международных стандартов в области защиты персональных данных.',
    },
    {
      kind: 'heading',
      number: '2.',
      text: 'Определения',
    },
    {
      kind: 'para',
      number: '2.1.',
      text: 'Файлы cookie — это небольшие текстовые файлы, которые сохраняются на устройстве Пользователя при использовании Приложения или посещении Сайта. Файлы cookie содержат информацию о действиях Пользователя, настройках интерфейса и технических параметрах устройства.',
    },
    {
      kind: 'para',
      number: '2.2.',
      text: 'Идентификаторы устройства — уникальные идентификаторы, создаваемые мобильными платформами (IDFA, Android ID, Firebase ID и др.), используемые для аналитики, обеспечения безопасности и статистики.',
    },
    {
      kind: 'heading',
      number: '3.',
      text: 'Цели обработки данных файлов cookie',
    },
    {
      kind: 'para',
      number: '3.1.',
      text: 'Компания использует файлы cookie и аналогичные технологии исключительно в следующих целях:',
    },
    {
      kind: 'bullet',
      text: 'a) обеспечение надлежащего функционирования Сайта и Приложения;',
    },
    {
      kind: 'bullet',
      text: 'b) запоминание пользовательских настроек, языка интерфейса и параметров авторизации;',
    },
    {
      kind: 'bullet',
      text: 'c) анализ активности пользователей для улучшения функциональности и интерфейса;',
    },
    {
      kind: 'bullet',
      text: 'd) повышение безопасности, предотвращение мошенничества и технических сбоев;',
    },
    {
      kind: 'bullet',
      text: 'e) статистический анализ и повышение качества обслуживания;',
    },
    {
      kind: 'bullet',
      text: 'f) персонализация контента и рекомендаций.',
    },
    {
      kind: 'para',
      number: '3.2.',
      text: 'Файлы cookie не используются для принятия автоматизированных решений, влекущих юридические последствия для Пользователя.',
    },
    {
      kind: 'heading',
      number: '4.',
      text: 'Категории обрабатываемых данных',
    },
    {
      kind: 'para',
      number: '4.1.',
      text: 'При использовании файлов cookie Компания может обрабатывать следующие обезличенные данные:',
    },
    {
      kind: 'bullet',
      text: 'IP-адрес и регион устройства;',
    },
    {
      kind: 'bullet',
      text: 'дата и время посещения;',
    },
    {
      kind: 'bullet',
      text: 'тип и версия операционной системы, браузера, модель устройства;',
    },
    {
      kind: 'bullet',
      text: 'источник перехода на Сайт или установки Приложения;',
    },
    {
      kind: 'bullet',
      text: 'действия Пользователя (просмотр страниц, клики, навигация, взаимодействие с элементами интерфейса);',
    },
    {
      kind: 'bullet',
      text: 'технические ошибки, сбои и системные журналы.',
    },
    {
      kind: 'para',
      number: '4.2.',
      text: 'Файлы cookie не содержат данных, напрямую идентифицирующих Пользователя.',
    },
    {
      kind: 'heading',
      number: '5.',
      text: 'Используемые сервисы',
    },
    {
      kind: 'para',
      number: '5.1.',
      text: 'Компания может использовать необходимые сервисы для сбора статистики и анализа производительности.',
    },
    {
      kind: 'para',
      number: '5.2.',
      text: 'Данные передаются сервисам в обезличенной форме. Использование сервисов регулируется их собственными политиками конфиденциальности, с которыми Пользователь может ознакомиться на соответствующих веб-сайтах.',
    },
    {
      kind: 'heading',
      number: '6.',
      text: 'Правовые основания обработки',
    },
    {
      kind: 'para',
      number: '6.1.',
      text: 'Данные файлов cookie обрабатываются на основании:',
    },
    {
      kind: 'bullet',
      text: 'a) согласия Пользователя, выраженного при первом запуске Приложения или посещении Сайта путем нажатия кнопки «OK» или «Принять» в уведомлении о файлах cookie;',
    },
    {
      kind: 'bullet',
      text: 'b) необходимости обработки для исполнения Пользовательского соглашения.',
    },
    {
      kind: 'para',
      number: '6.2.',
      text: 'Согласие Пользователя фиксируется с помощью простой электронной подписи в виде указанного действия в интерфейсе.',
    },
    {
      kind: 'heading',
      number: '7.',
      text: 'Управление файлами cookie и отзыв согласия',
    },
    {
      kind: 'para',
      number: '7.1.',
      text: 'Пользователь имеет право в любое время:',
    },
    {
      kind: 'bullet',
      text: 'удалить сохраненные файлы cookie через настройки браузера или операционной системы;',
    },
    {
      kind: 'bullet',
      text: 'запретить установку файлов cookie;',
    },
    {
      kind: 'bullet',
      text: 'отозвать согласие на их обработку, направив запрос на support@aura-vibe.site.',
    },
    {
      kind: 'para',
      number: '7.2.',
      text: 'Отказ от использования файлов cookie может повлечь частичное или полное ограничение доступа к функциям Сайта и Приложения.',
    },
    {
      kind: 'heading',
      number: '8.',
      text: 'Срок хранения данных',
    },
    {
      kind: 'para',
      number: '8.1.',
      text: 'Срок хранения файлов cookie зависит от их типа и не превышает 24 месяцев с даты последнего взаимодействия Пользователя с Сайтом или Приложением.',
    },
    {
      kind: 'para',
      number: '8.2.',
      text: 'По истечении срока хранения файлы cookie автоматически удаляются либо при очистке памяти устройства Пользователем.',
    },
    {
      kind: 'heading',
      number: '9.',
      text: 'Передача и защита данных',
    },
    {
      kind: 'para',
      number: '9.1.',
      text: 'Доступ к данным файлов cookie предоставляется только уполномоченным сотрудникам и партнерам Компании, участвующим в поддержке и анализе сервисов.',
    },
    {
      kind: 'para',
      number: '9.2.',
      text: 'Все партнеры обязуются соблюдать конфиденциальность и обеспечивать уровень защиты, эквивалентный требованиям законодательства Республики Абхазия, Российской Федерации, стран СНГ и международных стандартов.',
    },
    {
      kind: 'para',
      number: '9.3.',
      text: 'Компания применяет технические и организационные меры безопасности, включая шифрование соединения (HTTPS), контроль доступа и аудит операций.',
    },
    {
      kind: 'heading',
      number: '10.',
      text: 'Трансграничная передача',
    },
    {
      kind: 'para',
      number: '10.1.',
      text: 'При использовании Firebase, Google Analytics и других зарубежных аналитических инструментов возможна трансграничная передача обезличенных данных.',
    },
    {
      kind: 'para',
      number: '10.2.',
      text: 'Такая передача осуществляется только при условии обеспечения адекватного уровня защиты персональных данных либо на основании согласия Пользователя.',
    },
    {
      kind: 'heading',
      number: '11.',
      text: 'Права пользователя',
    },
    {
      kind: 'para',
      number: '11.1.',
      text: 'Пользователь имеет право:',
    },
    {
      kind: 'bullet',
      text: 'a) получать информацию об обработке данных файлов cookie;',
    },
    {
      kind: 'bullet',
      text: 'b) требовать удаления или ограничения их обработки;',
    },
    {
      kind: 'bullet',
      text: 'c) отозвать согласие на использование файлов cookie;',
    },
    {
      kind: 'bullet',
      text: 'd) подавать жалобы в уполномоченные органы в случае нарушения его прав.',
    },
    {
      kind: 'heading',
      number: '12.',
      text: 'Изменения Политики',
    },
    {
      kind: 'para',
      number: '12.1.',
      text: 'Компания имеет право обновлять настоящую Политику в одностороннем порядке в связи с изменениями функциональности, технологий или законодательства.',
    },
    {
      kind: 'para',
      number: '12.2.',
      text: 'Новая версия вступает в силу с момента ее опубликования на Сайте и в Приложении.',
    },
    {
      kind: 'para',
      number: '12.3.',
      text: 'При внесении существенных изменений Компания уведомляет Пользователей с помощью всплывающего уведомления или письма, направленного на адрес электронной почты, указанный при регистрации.',
    },
    {
      kind: 'heading',
      number: '13.',
      text: 'Контактная информация',
    },
    {
      kind: 'para',
      text: 'По всем вопросам, связанным с обработкой данных файлов cookie, Пользователь может обращаться:',
    },
    {
      kind: 'bullet',
      text: 'Email: support@aura-vibe.site',
    },
    {
      kind: 'bullet',
      text: 'Почтовый адрес: ООО «Falcon», проспект Мира 16, г. Сухум, Республика Абхазия.',
    },
  ],
};
